import { Share2, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { formatPrice } from "@/lib/api";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.7-.3zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" />
  </svg>
);

export const ShareButtons = ({ product }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = `${product.name} — ${formatPrice(product.price)} sur TWELVE 12-SHOP`;

  const nativeShare = async () => {
    try {
      await navigator.share({ title: product.name, text, url });
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Partage impossible");
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Lien copié");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Impossible de copier le lien");
    }
  };

  const btn = "inline-flex items-center gap-2 border border-white/15 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.15em] text-smoke hover:text-white hover:border-white/40 transition-colors";

  return (
    <div data-testid="share-buttons" className="flex flex-wrap items-center gap-2 mb-10">
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ash mr-1">Partager</span>
      {typeof navigator !== "undefined" && navigator.share && (
        <button data-testid="share-native-button" onClick={nativeShare} className={btn}>
          <Share2 size={14} /> Partager
        </button>
      )}
      <a
        data-testid="share-whatsapp-link"
        href={`https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={btn}
      >
        <WhatsAppIcon /> WhatsApp
      </a>
      <button data-testid="share-copy-button" onClick={copyLink} className={btn}>
        {copied ? <Check size={14} className="text-volt" /> : <Link2 size={14} />} {copied ? "Copié" : "Copier le lien"}
      </button>
    </div>
  );
};
